import {assignInlineVars} from '@vanilla-extract/dynamic';
import cx from 'classnames';

import {ProgressBarProps} from './ProgressBar.types';

import * as css from './ProgressBar.css';

const getValueAsInsetPercent = (value = 0, maxValue = 100) =>
  `${100 - Math.max(Math.min((value / maxValue) * 100, 100), 0)}%`;

export const ProgressBar = ({
  className,
  maxValue = 100,
  value = 0,
  variant = 'primary',
  ...otherProps
}: ProgressBarProps) => {
  return (
    <div
      aria-label="Progress"
      aria-valuemax={maxValue || 100}
      aria-valuemin={0}
      aria-valuenow={value || 0}
      className={cx(className, css.root({variant}))}
      role="meter"
      style={assignInlineVars({[css.progressVar]: getValueAsInsetPercent(value, maxValue)})}
      {...otherProps}
    />
  );
};
